module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/vintage-4c38457f2ba497d68c7dcae7f38cb943.jpg";